import React from 'react';
import styled from 'styled-components';
import logo_d from '../assets/logo_d.png';
import search_d from '../assets/search_d.png';

const HeaderWrapper = styled.div`
  box-sizing: border-box;
  padding: 2.25rem 22.5rem;
  height: 10rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid #e5e5e5;

  @media screen and (max-width: 1199px) {
    height: 8.5rem;
    padding: 0;
    padding-top: 0.625rem;
    border-bottom: none;
  }

  @media screen and (max-width: 1599px) {
    justify-content: center;
    align-items: center;
  }
`;

const HeaderLeft = styled.div`
  img {
    max-width: 100%;
    height: auto;
    padding-right: 2.5rem;
    padding-bottom: 0.625rem;
    vertical-align: middle;
  }

  input {
    padding: 0 0.9375rem;
    box-sizing: border-box;
    outline: none;
    border: 2px solid #1c92c1;
    color: #767676;
    width: 18.75rem;
    height: 2.5rem;
    background: url(${search_d}) no-repeat 95% 50%;
    /* filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25)); */
    font-size: 0.875rem;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  }

  @media screen and (max-width: 1199px) {
    img {
      max-width: 45%;
    }

    input {
      padding: 0 3rem 0 1rem;
      box-sizing: border-box;
      outline: none;
      border: 2px solid #e5e5e5;
      border-radius: 20px;
      color: #767676;
      width: 18.75rem;
      height: 2.5rem;
      background: url(${search_d}) no-repeat 95% 50%;
      font-size: 0.75rem;
      box-shadow: none;
    }
  }

  @media screen and (max-width: 1599px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

const HeaderRight = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  h3 {
    font-size: 1.125rem;
    font-weight: bold;
    color: #181818;
  }

  p {
    padding-top: 10px;
    font-size: 0.75rem;
    color: #767676;
  }

  @media screen and (max-width: 1599px) {
    display: none;
  }
`;

const Header = ({ onChange }) => {
  return (
    <HeaderWrapper>
      <HeaderLeft>
        <a href="/">
          <img src={logo_d} alt="logo_d" />
        </a>
        <input
          type="text"
          placeholder="상호를 입력하세요"
          onChange={onChange}
        />
      </HeaderLeft>
      <HeaderRight>
        <h3>032-888-4241 05:00 ~ 21:00 (연중무휴)</h3>
        <p>젓갈부 첫째 주 화요일 휴무 | 건어부 첫째, 셋째 주 수요일 휴무</p>
      </HeaderRight>
    </HeaderWrapper>
  );
};

export default Header;
